import { render } from "./AuthenticationCard.vue?vue&type=template&id=40c2019b"
const script = {}

import exportComponent from "/var/www/app/resources/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__